import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment";

const Sending = ({ dispatch_post_authin_code }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  useEffect(() => {}, []);

  const [code, set_code] = useState("");

  return (
    <div class="d-flex flex-column justify-content-center text-white vh-100">
      <div id="particle" className="particles-box" />
      <main role="main" className="main">
        <div className="container">
          <section className="login-section mx-auto text-center">
            <div className="animated tada">
              <i className="far fa-paper-plane text-impact display-1 mb-3" />
            </div>
            <h1 className="display-4 font-weight-bold">
              {t("メッセージを送信しました。")}
            </h1>
            <p className="lead">{t("返信をお待ちください。")}</p>
            <a
              className="btn btn-outline-light mt-3"
              href="index.html"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/top`,
                });
                window.scroll(0, 0);
              }}
            >
              <i className="fas fa-home" /> {t("トップページへ")}
            </a>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Sending;
